// Plays a base64-encoded mp3 returned by the backend TTS endpoints.
import { logError } from "@/lib/log";

let current = null;

export function playBase64Mp3(base64) {
  try {
    stopAudio();
    const src = base64.startsWith("data:") ? base64 : `data:audio/mp3;base64,${base64}`;
    const audio = new Audio(src);
    current = audio;
    const p = audio.play();
    if (p && p.catch) p.catch(() => {});
    return audio;
  } catch {
    return null;
  }
}

export function stopAudio() {
  if (current) {
    try {
      current.pause();
      current.currentTime = 0;
    } catch (e) { logError("stopAudio", e); }
    current = null;
  }
}
